<template>
  <v-container 
    class="justify-center py-12"
    fill-height
    style="gap: 16px"
  >
    <div 
      v-for="(card, index) in items"
      :ref="`ticket-${index}`"
      :class="['card', {'featured-card': card.destaque}]"
      :style="{
        height: `${card.destaque ? cardHeights.featured : cardHeights.others}px`,
        'background-color': layout.bgColor,
        '--accentColor': layout.accentColor1,
        '--featuredBgColor': layout.featuredBgColor1,
        '--widthCard': `${layout.width || width}px`,
        '--featuredWidthCard': `${layout.featuredWidth || featuredWidth}px`        
      }"
      :key="index"
      @click="$emit('onBuyTicket', card)"
    >
      <div class="d-flex justify-center" style="overflow: hidden; white-space: nowrap; text-overflow: ellipsis">
        <h1 
          :ref="`ticket-title-${index}`" 
          class="title" 
          :style="{color: !card.destaque ? layout.accentColor1 : layout.textColor2}" 
          @mouseenter="isEllipsed(`ticket-title-${index}`)" 
          @mouseleave="resetTooltip"
        >
          <v-tooltip bottom max-width="220" :disabled="!infoTooltip.show" :color="layout.accentColor1">
            <template v-slot:activator="{ on }">
              <span 
                v-on="on" 
                :style="{
                  color: !card.destaque ? layout.accentColor1 : layout.textColor2,
                }"
              >
                {{getTicketName(card)}}
              </span>
            </template>
            <div :style="{'font-size': '0.8rem'}">
              {{getTicketName(card)}}
            </div>
          </v-tooltip>
        </h1>
      </div>

      <div class="d-flex justify-center" :style="{color: !card.destaque ? layout.textColor1 : layout.textColor2}">
        <div class="d-flex align-center pr-1">R$</div>
        <h2 class="price">{{formatValue(card.valor)}}</h2>
        <span class="pt-2" :style="{color: !card.destaque ? layout.textColor1 : layout.textColor2}">,00</span>
      </div>
      <!-- <span class="d-block msg" v-html="card.mensagem"></span> -->

      <div class="d-flex flex-column pt-6" style="gap: 12px">
        <Button :label="settings.itemsV2Button" :color="layout.accentColor1"/>
        <!-- <Button label="Comprar como parceiro" outlined text-color="bt_color" text-size="0.75rem" @click="$emit('onBuyTicketLikePartner', card)"/> -->
      </div>

      <div class="d-flex flex-column align-start pt-6" style="gap: 4px">
        <span 
          v-if="
            settings.itemsV2Message && 
            showItemsWithAtLeastOneOccurence.length > 0 && 
            showItemsWithAtLeastOneOccurence.some(group => group.items.length > 0)
          " 
          class="d-block pb-4 items-msg"
          :style="{color: !card.destaque ? layout.textColor1 : layout.textColor2}"
        >
          {{settings.itemsV2Message}}
        </span>

        <div v-for="(group, i) in showItemsWithAtLeastOneOccurence" :key="`${card.nome}-item-${i}`">
          <div 
            v-if="group.group && group.items.length > 0" 
            :class="['d-flex flex-column align-start items-msg pb-3', {'pt-3': i !== 0}]"
            :style="{color: !card.destaque ? layout.textColor1 : layout.textColor2}"
          >
            {{group.group}}
          </div>
          <section
            v-for="(itemGroup, indexGroup) in group.items" 
            :key="`${group.group}-itemGroup-${indexGroup}`"
            :class="['d-flex justify-start align-center', {'pt-3': indexGroup !== 0}]"  
          >
            <div class="item-circle mr-3">
              <div 
                class="item-circle" 
                style="position: absolute !important; top: 0; left: 0; backgroundColor: red !important;"
                :style="{
                  position: 'absolute !important',
                  top: 0,
                  left: 0,
                  backgroundColor: card.itens_incluidos.includes(itemGroup.id) ? 
                    !card.destaque ? layout.checkColor1.bgChecked : layout.checkColor2.bgChecked
                    : 
                    !card.destaque ? layout.checkColor1.bgNotChecked : layout.checkColor2.bgNotChecked,
                  opacity: card.itens_incluidos.includes(itemGroup.id) ? 
                    !card.destaque ? 0.1 : 1 
                    : 1
                }"
              ></div>

              <v-icon 
                v-if="card.itens_incluidos.includes(itemGroup.id)" 
                size="14" 
                style="padding-top: 2px" 
                :color="!card.destaque ? layout.checkColor1.colorChecked : layout.checkColor2.colorChecked"
              >
                fa-solid fa-check
              </v-icon>

              <v-icon v-else size="14" :color="!card.destaque ? layout.checkColor1.colorNotChecked : layout.checkColor2.colorNotChecked">
                fa-regular fa-xmark
              </v-icon>
            </div>
            <div 
              class="item-desc" 
              :style="{
                color: card.itens_incluidos.includes(itemGroup.id) ? 
                  card.destaque ? layout.textColor2 : layout.accentColor1 
                  : 
                  card.destaque ? layout.textColor2 : '#666D80'
                }"
            >
              {{itemGroup.description}}
            </div>
          </section>
        </div>
      </div>
    </div>
  </v-container>
</template>

<script> 
import {mapGetters} from 'vuex'
import Button from '../../_v2/ui/Button.vue'
import { TICKETS_GET_DEFAULT_WIDTH } from '../../../schemas/sections'

export default {
  name: 'newLayout3',
  components: {Button},
  props: {
    settings: {type: Object},
    splitArray: {type: Array},
    openCheckout: {type: Function},
    getTicketsForLayoutV2: {type: Function}
  },

  computed: {
    ...mapGetters(['products', 'loadingCheckout']),
    layout () {
      return this.settings.layoutStyle.newLayout3
    },

    showItemsWithAtLeastOneOccurence () {
      const itemsV2DescParsed = JSON.parse(JSON.stringify(this.settings.itemsV2Desc))
      itemsV2DescParsed.forEach(group => {
        const uselessItem = []

        group.items.forEach((item) => {
          const isItBeingUsed = this.settings.itemsV2.some(ticket => ticket.itens_incluidos.includes(item.id))
          if (!isItBeingUsed) uselessItem.push(item.id)
        })

        group.items = group.items.filter(item => !uselessItem.includes(item.id))
      })
      return itemsV2DescParsed      
    }
  },

  data: () => ({
    cardHeights: {featured: null, others: null},
    infoTooltip: {ref: '', show: false},
    items: [],
    width: TICKETS_GET_DEFAULT_WIDTH('newLayout3').width,
    featuredWidth: TICKETS_GET_DEFAULT_WIDTH('newLayout3').featuredWidth      
  }),

  mounted () {
    if (this.products && this.products.products) this.getTickets(this.products.products)
  },

  methods: {
    getTickets (products) {
      if (products && products.length > 0) {
        this.items = this.getTicketsForLayoutV2(this.settings.itemsV2)
        this.$forceUpdate()
      } else this.items = []
    },

    getTicketName (item) {
      let productName = 'Ingresso'
      if (item && this.settings.showTypeOfTicket) productName = item.nome_tipo ? `${item.nome} - ${item.nome_tipo}` : item.nome
      else if (item && !this.settings.showTypeOfTicket) productName = item.nome
      
      return productName      
    },    

    formatValue (price) {
      const formatedValue = price ? price.split(',00')[0] : price
      return formatedValue
    },

    isEllipsed (ref) {
      const cardTitle = this.$refs[ref]
      const isCardTitleEllipsed = cardTitle[0].scrollWidth > cardTitle[0].clientWidth
      Object.assign(this.infoTooltip, {ref, show: isCardTitleEllipsed})  
    },

    resetTooltip () {
      Object.assign(this.infoTooltip, {ref: '', show: false})  
    }    
  },

  watch: {
    'products.products': {
      deep: true,
      handler (v) { this.getTickets(v) }
    },

    'settings.itemsV2': {
      deep: true,
      handler (v) { 
        this.getTickets(v) 
      },
    },

    'settings.itemsV2Message': {
      deep: true,
      handler () { 
        this.getTickets(this.settings.itemsV2) 
      },
    },    
  },    
}
</script>

<style scoped>
.card {
  border-radius: 0px;
  padding: 28px 20px 28px 20px;
  width: var(--widthCard) !important;
  text-align: center;
  position: relative;
  transition: all 0.3s;
}

.card:hover {
  cursor: pointer;
  transform: translateY(-8px);
}

.card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: 2px solid var(--accentColor) !important;
  opacity: 0.3;
  border-radius: 0px;
}

.card .title {
  text-transform: uppercase;
  font-weight: 700;
  font-size: 28px !important;
  line-height: 124%;
  padding-bottom: 16px;
  overflow: hidden;
  text-overflow: ellipsis;
  z-index: 1;
}

.card .price {
  font-size: 48px;
  line-height: 124%;
  letter-spacing: 0;
  font-weight: 700;
}

.card .msg {
  font-size: 12px;
  font-weight: 400;
  line-height: 124%;
}

.card .items-msg {
  font-size: 14px;
  font-weight: 700;
  line-height: 124%;
}

.featured-card {
  width: var(--featuredWidthCard) !important;
  position: relative;
  background-color: var(--featuredBgColor) !important;
}

.featured-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: 2px solid var(--accentColor) !important;
  border-radius: 0px;
  opacity: 1;
}

.item-circle {
  height: 20px;
  width: 20px;
  max-height: 20px;
  max-width: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  position: relative;
}

.item-desc {
  display: flex;
  flex: 1;
  font-size: 13px;
  line-height: 124%;
  font-weight: 400;
  text-align: start;
}

@media (max-width: 600px) {
  .card {
    width: 80% !important;
  }
}
</style>